import React, { useEffect, useState } from "react";
import { Button, Col, Form, FormControl, Modal, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { FieldError, Loader, Notification } from "../../../../assets";
import { useAuth } from "../../../../Navigation/Auth/ProvideAuth";
import {
  getAllZoomMeetingAction,
  getMeetingRecord,
  updateScheduleMeeting,
} from "../../../../redux/actions";

const UpdateMeeting = ({ show, onHide, meetingRecord }) => {
  const { register, errors, handleSubmit, reset } = useForm();

  let dispatch = useDispatch();
  let auth = useAuth();
  const zoomRedux = useSelector((state) => state.zoom);

  const [allowVideo, setAllowVideo] = useState(
    zoomRedux?.getSingleMeeting?.settings?.host_video
  );
  const [allowParticipant, setAllowParticipant] = useState(
    zoomRedux?.getSingleMeeting?.settings?.participant_video
  );
  const [joinAnyTime, setJoinAnyTime] = useState(
    zoomRedux?.getSingleMeeting?.settings?.join_before_host
  );
  const [muteParticipant, setMuteParticipant] = useState(
    zoomRedux?.getSingleMeeting?.settings?.mute_upon_entry
  );

  useEffect(() => {
    dispatch(getMeetingRecord(meetingRecord.id, zoomRedux?.user.email));
  }, [dispatch]);

  useEffect(() => {
    if (zoomRedux?.getSingleMeetingSuccess) {
      setAllowParticipant(
        zoomRedux?.getSingleMeeting?.settings?.participant_video
      );
      setAllowVideo(zoomRedux?.getSingleMeeting?.settings?.host_video);
      setJoinAnyTime(zoomRedux?.getSingleMeeting?.settings?.join_before_host);
      setMuteParticipant(
        zoomRedux?.getSingleMeeting?.settings?.mute_upon_entry
      );
    }
  }, [dispatch, zoomRedux]);

  function onSubmit(data) {
    let reSchedule = {
      email:
        auth.user.email === "irfan@xevensolutions.com"
          ? "business@xevensolutions.com"
          : auth.user.email,
      agenda: data.agenda,
      start_time: data.start_time,
      timezone: data.timezone,
      participant_video: allowParticipant,
      host_video: allowVideo,
      private_meeting: false,
      auto_recording: "none",
      join_before_host: joinAnyTime,
      mute_upon_entry: muteParticipant,
    };
    dispatch(updateScheduleMeeting(meetingRecord?.id, reSchedule, moveToNext));
  }
  function moveToNext(res) {
    Notification(res.data.message, res.data.Succeeded ? "success" : "error");
    if (res.data.Succeeded) {
      onHide();
      dispatch(
        getAllZoomMeetingAction({ page_number: 1, email: zoomRedux.user.email })
      );
    }
  }

  return (
    <div>
      <Modal
        size="md"
        className="p-0"
        aria-labelledby="contained-modal-title-vcenter"
        id="user-welcome-card"
        centered
        show={show}
        onHide={onHide}
        backdrop="static"
        keyboard={false}
        closeButton
      >
        <Modal.Header
          className="mx-4 pb-3 px-0 d-flex align-items-end"
          closeButton
        >
          <h5 className="generic-heading-level-3">Schedule Meeting</h5>
        </Modal.Header>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Body className="py-0 px-0 px-2">
            <div className="px-3 b7 mt-2">
              <Row>
                <Col lg="12" className="mt-2 mb-2">
                  <Form.Group className="">
                    <label className="salary-labels">{"Meeting Title"}</label>
                    <Form.Control
                      type="Text"
                      placeholder="Meeting Title"
                      name="agenda"
                      defaultValue={zoomRedux?.getSingleMeeting?.agenda}
                      ref={register({
                        required: true,
                        pattern: /[^\s]+/,
                      })}
                    />
                    {errors.agenda && (
                      <FieldError message={"This Field is Required"} />
                    )}
                  </Form.Group>
                </Col>

                <Col lg="7 ">
                  <Form.Group className="">
                    <label className="salary-labels">{"Date & Time"}</label>
                    <FormControl
                      type="datetime-local"
                      placeholder="Date"
                      name="start_time"
                      className="form_control_date "
                      defaultValue={zoomRedux?.getSingleMeeting?.start_time}
                      ref={register({
                        required: true,
                        pattern: /[^\s]+/,
                      })}
                    />
                    {errors.start_time && (
                      <FieldError message={"This Field is Required"} />
                    )}
                  </Form.Group>
                </Col>
                <Col lg="5 ">
                  <Form.Group className="">
                    <label className="salary-labels">{"Time Zone"}</label>
                    <Form.Control
                      as="select"
                      defaultValue={zoomRedux?.getSingleMeeting?.timezone}
                      name="timezone"
                      ref={register({
                        required: true,
                        pattern: /[^\s]+/,
                      })}
                    >
                      <option value="">Select Time Zone</option>
                      <option value="Asia/Tashkent">Asia/Karachi</option>
                    </Form.Control>
                    {errors.timezone && (
                      <FieldError message={"This Field is Required"} />
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col lg="5">
                  <label className="salary-labels">{"Video"}</label>
                  <div className="d-flex align-items-center py-1">
                    <span className="pr-3 f-12 specific-color">Host:</span>
                    <div className="switchToggle">
                      <input
                        type="checkbox"
                        name="host_video"
                        id="host-video-toggle"
                        onChange={() => {
                          setAllowVideo(!allowVideo);
                        }}
                        checked={allowVideo}
                        ref={register()}
                      />
                      <label htmlFor="host-video-toggle">Toggle</label>
                    </div>
                  </div>
                </Col>
                <Col lg="7 align-self-end">
                  <div className=" py-1 d-flex align-items-center">
                    <span className="pr-3 f-12 specific-color">
                      participant:
                    </span>
                    <div className="switchToggle">
                      <input
                        type="checkbox"
                        name="participant_video"
                        id="participant-video-toggle"
                        onChange={() => {
                          setAllowParticipant(!allowParticipant);
                        }}
                        checked={allowParticipant}
                        ref={register()}
                      />
                      <label htmlFor="participant-video-toggle">Toggle</label>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row className="checkbox-size">
                <label className="salary-labels px-3 py-2">
                  {"Advance Options"}
                </label>
                <Col lg="12">
                  <Form.Check
                    inline
                    enable
                    label="Allow participant to join anytime"
                    type="checkbox"
                    defaultChecked={joinAnyTime}
                    name="join_before_host"
                    className="f-12 check-box-generic"
                    onChange={(e) => setJoinAnyTime(e.target.checked)}
                  />
                </Col>
                <Col lg="12">
                  <Form.Check
                    inline
                    enable
                    name="mute_upon_entry"
                    defaultChecked={muteParticipant}
                    label="Mute participant upon entry"
                    type="checkbox"
                    className="f-12 check-box-generic"
                    onChange={(e) => setMuteParticipant(e.target.checked)}
                  />
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <Button
                    className={`w-100 my-3 rounded-0 send-button btn-primary-login f-12 fw6 ${
                      zoomRedux.updateScheduleMeetingLoading && "disabled"
                    }`}
                    type="submit"
                    disabled={zoomRedux.updateScheduleMeetingLoading}
                  >
                    {zoomRedux.updateScheduleMeetingLoading === true ? (
                      <Loader customClass="m-0 " spinnerVariant="white" />
                    ) : (
                      "Update"
                    )}
                  </Button>
                </Col>
              </Row>
            </div>
          </Modal.Body>
        </form>
      </Modal>
    </div>
  );
};

export default UpdateMeeting;
